// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/css/async/" + (chunkId === "4777" ? "monaco-editor" : chunkId) + "." + {"4589": "e5b33855","4777": "13f44d2c","4846": "d8530b68","4980": "25e50ce7","5213": "9eba3fd9","5324": "2a5f2a80","5485": "40e2b10f","9200": "e84ea252",}[chunkId] + ".css"
}